import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { Alert, Autocomplete, Button, InputLabel, OutlinedInput, Stack, Typography } from "@mui/material";
import { forwardRef, useCallback, useState } from "react";
import Modal, { CommonModalProps } from "..";
import { DbIngestPersonalBackupInfos } from "../../../Core/Api/Types/db-ingest-personal-backup-infos";
import {
  FetchPackAndTitlesThenFillWithBackup,
  GetConfigBackups,
} from "../../../Redux/Reducers/redux-slice-new-request";
import { useAppDispatch, useAppSelector } from "../../../Redux/redux-store";
import { useTranslation } from "react-i18next";

export type ModalNewRequestLoadConfigElementProps = {};
export type ModalNewRequestLoadConfigProps = CommonModalProps<ModalNewRequestLoadConfigElementProps>;

const ModalNewRequestLoadConfig = forwardRef<any, ModalNewRequestLoadConfigProps>((props, ref) => {
  const { t } = useTranslation();
  const { closeModal } = props;

  const dispatch = useAppDispatch();

  const backups = useAppSelector(GetConfigBackups);

  const [selectedBackup, setSelectedBackup] = useState<DbIngestPersonalBackupInfos | null>(null);

  const onLoadClick = useCallback(() => {
    if (selectedBackup) {
      dispatch(FetchPackAndTitlesThenFillWithBackup(selectedBackup));
      closeModal();
    }
  }, [selectedBackup]);

  return (
    <Modal
      reference={ref}
      title={t("modal:title.restoreConfiguration")}
      closeModal={closeModal}
      width={800}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Button variant="outlined" onClick={closeModal}>
            {t("common:close")}
          </Button>
          <Button variant="outlined" color="success" onClick={onLoadClick} disabled={!selectedBackup}>
            {t("button:loadConfiguration")}
          </Button>
        </Stack>
      }
    >
      <Stack spacing={2}>
        <Typography variant="h5">{t("modal:modalNewRequestLoadConfig.body.slectConfigurationToRestore")}</Typography>
        <Stack spacing={1}>
          <InputLabel>{t("field:label.availableConfigurations")}</InputLabel>
          <Autocomplete
            options={backups}
            getOptionLabel={(option) => option.name!}
            onChange={(event, value) => setSelectedBackup(value)}
            value={selectedBackup}
            renderInput={(params) => (
              <OutlinedInput
                {...params.InputProps}
                inputProps={params.inputProps}
                placeholder={t("field:placeholder.selectConfiguration")}
                sx={{ width: "100%" }}
              />
            )}
            popupIcon={<ExpandMoreRoundedIcon />}
          />
          <Alert severity="info">{t("alert:info.fetchingNonSavedPlaceholdersInfo")}</Alert>
        </Stack>
      </Stack>
    </Modal>
  );
});

export default ModalNewRequestLoadConfig;
